import { memo } from "react";
import { TConfigItemType } from "../../models";
import { CheckboxFieldTypeSpecificProps } from "./fieldTypeEditors/CheckboxFieldTypeSpecificProps";
import { CountrySelectFieldTypeSpecificProps } from "./fieldTypeEditors/CountrySelectFieldTypeSpecificProps";
import { DateFieldTypeSpecificProps } from "./fieldTypeEditors/DateFieldTypeSpecificProps";
import { FilePickerFieldTypeSpecificProps } from "./fieldTypeEditors/FilePickerFieldTypeSpecificProps";
import { PepFieldTypeSpecificProps } from "./fieldTypeEditors/PepFieldTypeSpecificProps";
import { SelectFieldTypeSpecificProps } from "./fieldTypeEditors/SelectFieldTypeSpecificProps";
import { SourceOfActiveFieldTypeSpecificProps } from "./fieldTypeEditors/SourceOfActiveFieldTypeSpecificProps";
import { TaxIdFieldTypeSpecificProps } from "./fieldTypeEditors/TaxIdFieldTypeSpecificProps";
import { TextFieldTypeSpecificProps } from "./fieldTypeEditors/TextFieldTypeSpecificProps";
import { UrlFieldTypeSpecificProps } from "./fieldTypeEditors/UrlFieldTypeSpecificProps";
import { FieldTypeEditorProps } from "./types";

const UNSUPPORTED_FIELD_TYPE_EDITOR = (_props: FieldTypeEditorProps) => null;

const FIELD_TYPE_EDITOR_REGISTRY: Partial<
  Record<TConfigItemType, (props: FieldTypeEditorProps) => JSX.Element | null>
> = {
  [TConfigItemType.TEXT]: TextFieldTypeSpecificProps,
  [TConfigItemType.URL]: UrlFieldTypeSpecificProps,
  [TConfigItemType.SELECT]: SelectFieldTypeSpecificProps,
  [TConfigItemType.CHECKBOX]: CheckboxFieldTypeSpecificProps,
  [TConfigItemType.FILE_PICKER]: FilePickerFieldTypeSpecificProps,
  [TConfigItemType.TAX_ID]: TaxIdFieldTypeSpecificProps,
  [TConfigItemType.PEP]: PepFieldTypeSpecificProps,
  [TConfigItemType.SOURCE_OF_ACTIVE]: SourceOfActiveFieldTypeSpecificProps,
  [TConfigItemType.COUNTRY_SELECT]: CountrySelectFieldTypeSpecificProps,
  [TConfigItemType.DATE]: DateFieldTypeSpecificProps,
} as const;

export const FieldTypeSpecificProps = memo((props: FieldTypeEditorProps) => {
  const Component = FIELD_TYPE_EDITOR_REGISTRY[props.field.type] ?? UNSUPPORTED_FIELD_TYPE_EDITOR;
  return <Component {...props} />;
});
